'use client';

import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Chip, Typography, useTheme } from '@mui/material';

export interface ChipNavBarItem {
  label: string;
  isDropdown?: boolean;
  isActive?: boolean;
  showDot?: boolean;
  dotColor?: string;
  onClick?: () => void;
}

interface ChipNavBarProps {
  items: ChipNavBarItem[];
  sx?: any;
}

export function ChipNavBar({ items, sx }: ChipNavBarProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        mt: 2,
        flexWrap: 'wrap',
        ...sx,
      }}
    >
      {items.map((item, index) => (
        <Chip
          key={index}
          onClick={item.onClick}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {item.showDot && (
                <FiberManualRecordIcon
                  sx={{
                    fontSize: 10,
                    color: item.dotColor || theme.palette.error.main,
                  }}
                />
              )}
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                  fontSize: '0.85rem',
                  color: item.isActive ? theme.palette.text.primary : theme.palette.text.secondary,
                }}
              >
                {item.label}
              </Typography>
              {item.isDropdown && (
                <KeyboardArrowDownIcon
                  sx={{
                    fontSize: 18,
                    color: theme.palette.text.secondary,
                    ml: -0.5,
                  }}
                />
              )}
            </Box>
          }
          sx={{
            bgcolor: theme.palette.background.paper,
            borderRadius: '20px',
            height: 36,
            px: 0.5,
            border: 'none',
            cursor: 'pointer',
            transition: theme.transitions.create(['background-color'], {
              duration: theme.transitions.duration.shorter,
            }),
            '&:hover': {
              bgcolor: theme.palette.action.hover,
            },
            '& .MuiChip-label': {
              px: 1.5,
            },
          }}
        />
      ))}
    </Box>
  );
}
